<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" v-if="newModem">Добавить модем</h2>
        <h2 class="modal-title" v-else>Редактирование модема {{uid}}</h2>
        <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pb-0">
        <div v-if="newModem || noCommands" class="form-group">
          <label for="edit-modem-uid">{{newModem ? 'ID модема' : 'Номер модема'}}</label>
          <input type="text" class="form-control" :class="{'is-invalid': validationErrors.modemUid}" id="edit-modem-uid"
                 v-model="inputValue">
          <div v-for="error in validationErrors.modemUid" class="invalid-feedback">{{ error }}</div>
        </div>

        <div class="form-group">
          <label>Выбрать организацию</label>
          <server-select
            v-model="region"
            endpoint="regions/options"
            label="short_name"
          />
        </div>

        <div v-if="!newModem" class="form-group">
          <label>Сбросить пароль</label><br>
          <btn-action class="btn btn-outline-danger" @click="resetPassword">Сбросить пароль</btn-action>
        </div>

        <div v-if="!newModem && noCommands" class="form-group">
          <label>Удалить модем</label><br>
          <btn-action class="btn btn-outline-danger" @click="deleteModem">Удалить модем</btn-action>
        </div>
      </div>

      <div class="modal-footer">
        <btn-action class="btn btn-primary ml-auto" @click="save">Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>

<script>
  import api from '@/api'

  export default {
    props: ['id', 'newModem', 'currentRegion', 'uid', 'noCommands', 'number'],
    watch: {},
    data () {
      return {
        region: this.currentRegion || {id: null, name: 'Не выбрана'},
        inputValue: this.uid,
        validationErrors: {},
        machines: [],
      }
    },
    methods: {
      resetPassword () {
        if (window.confirm('Действительно сбросить пароль?')) {
          return api.put(`modems/${this.id}/resetPassword`)
        }
      },
      handleValidationError (error) {
        if (error.response && error.response.status === 422) {
          this.validationErrors = error.response.data.validation
        } else {
          throw error
        }
      },
      save () {
        let data = {
          modemUid: this.newModem ? this.inputValue : this.uid,
          region_id: this.region.id,
        }
        let emitData = {
          modemId: this.id,
          uid: this.newModem ? this.inputValue : this.uid,
          machineId: null,
          serial_number: '',
          region: this.region,
        }
        if (this.newModem) {
          return api
            .post('modems/', data)
            .then((data) => {
              emitData.modemId = data.data.id
              this.$emit('hide', emitData)
            })
            .catch(this.handleValidationError)
        } else {
          if (this.noCommands) {
            data.modemUid = this.inputValue
          }
          return api
            .put(`modems/${this.id}`, data)
            .then(({data}) => {
              emitData.number = data.number
              this.$emit('hide', emitData)
            })
            .catch(this.handleValidationError)
        }
      },
      deleteModem () {
        if (window.confirm('Удалить модем?')) {
          return api.put(`/modems/${this.uid}/delete`)
            .then(() => window.location.reload())
        }
      },
    },
  }
</script>

<style lang="scss"></style>



// WEBPACK FOOTER //
// resources/assets/js/components/modems/edit-modal.vue